import {
    Component,
    OnInit,
    Input,
    EventEmitter,
    ViewChild,
    TemplateRef,
    ContentChild, ElementRef, AfterViewInit, AfterContentInit, forwardRef
  } from "@angular/core";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
  
  @Component({
    selector: "ess-tab",
    templateUrl: './tab.html',
    styleUrls: ['./tab.scss']
  })
  export class SmartTabItem implements OnInit, AfterViewInit, AfterContentInit {
    
    // @Input()
    // label: string;
  
    // @Input()
    // isActive: boolean;

    // @ViewChild(forwardRef(() => 'label'), {static: false})
    // label: ElementRef;
    @ViewChild('label', {static: false})
    label: TemplateRef<any>;

    @ViewChild('body', {static: false})
    body: TemplateRef<any>;
  
    // labelHTML: SafeHtml;
    // bodyHTML: SafeHtml;

    // @ContentChild(SmartTabBody, {static: false})
    // body: SmartTabBody;
  
    // @ContentChild(SmartTabHeader, {static: false})
    // header: SmartTabHeader;
  
    constructor(private sanitizer: DomSanitizer) {}
  
    ngOnInit(): void {}

    ngAfterViewInit() {
        // this.labelHTML = this.getLabelHTML();
        // this.bodyHTML = this.getBodyHTML();
        // console.log('header is ' + this.headerHTML, this.title);
        // console.log('body is ' + this.bodyHTML, this.body);
    }

    ngAfterContentInit() {
        // this.headerHTML = this.getHeaderHTML();
        // this.bodyHTML = this.getBodyHTML();
        // console.log('header is ' + this.headerHTML, this.title);
        // console.log('body is ' + this.bodyHTML, this.body);
    }

    // getLabelHTML(): SafeHtml {
    //     if (this.label && this.label.nativeElement) {
    //         let el = this.label.nativeElement;
    //         return this.sanitizer.bypassSecurityTrustHtml(el.innerHTML);
    //     }
    //     return null;
    // }

    // getBodyHTML(): SafeHtml {
    //     if (this.body && this.body.nativeElement) {
    //         let el = this.body.nativeElement;
    //         return this.sanitizer.bypassSecurityTrustHtml(el.innerHTML);
    //     }
    //     return null;
    // }
  }
  